import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, updateDoc } from 'firebase/firestore';
import { db, storage } from '../firebase';
import dexie from '../offlineDB';

export async function syncSetRecordings(setData, user) {
  if (!navigator.onLine || !user || !setData?.id || !setData?.recordings?.length) return;

  const updatedRecordings = [];

  for (const rec of setData.recordings) {
    if (rec.url || !rec.localBlob) {
      updatedRecordings.push(rec);
      continue;
    }

    try {
      const ext = (rec.mimeType || rec.localBlob?.type || '').includes('mp4') ? 'mp4' : 'webm';
      const storagePath = `recordings/${user.uid}/sets/${setData.id}/${rec.id}.${ext}`;
      const storageRef = ref(storage, storagePath);
      await uploadBytes(storageRef, rec.localBlob);
      const url = await getDownloadURL(storageRef);

      updatedRecordings.push({
        id: rec.id,
        label: rec.label,
        duration: rec.duration,
        createdAt: rec.createdAt,
        mimeType: rec.mimeType || rec.localBlob?.type || null,
        url,
        storagePath
      });
    } catch (err) {
      console.error(`Failed to sync set recording ${rec.id}:`, err);
      updatedRecordings.push(rec);
    }
  }

  const safeForFirebase = updatedRecordings.map(r => ({
    id: r.id,
    label: r.label,
    duration: r.duration,
    createdAt: r.createdAt,
    mimeType: r.mimeType || null,
    url: r.url || null,
    storagePath: r.storagePath || null
  }));

  await updateDoc(doc(db, 'users', user.uid, 'sets', setData.id), {
    recordings: safeForFirebase,
    updatedAt: new Date().toISOString()
  });

  await dexie.sets.update(setData.id, {
    recordings: updatedRecordings,
    updatedAt: new Date().toISOString()
  });
}
